export class TimeEntryNotPresentTemplate {
    activate(params) {
        this.absences = params.data;
    }
}
